import React, { useContext, useEffect, useReducer, useRef } from 'react'
import { useTheme, makeStyles, Card } from '@material-ui/core'
import { useReportsQlikApi } from '../api/reportsQlik/reportsQlik.api'
import { QlikReport } from './QlikReport'
import { DashboardConfig } from './angular/DashboardConfig'
import { QlikUIContext } from '../QlikUIContext'
import { DialogModal } from './dialogModal'
import { Tabs, Tab, Button } from '@material-ui/core'
import { useQlik } from './RequireQlik'
import { QlikSyncButton } from './QlikSyncButton'
import { useTranslation } from 'react-i18next'
import { stylesMui } from './styles/dashboard.styles'

import styles from './css/qlik-report-styles.css'

function dashboardReducer(state, action) {
  switch (action.type) {
    case 'unmount': {
      return initialState
    }
    case 'loadReport': {
      let reportSelected = action.payload.dashboards.find(
        (p) => p.Active === true
      )
      return {
        ...state,
        dashboards: action.payload.dashboards,
        report:
          reportSelected !== undefined
            ? reportSelected
            : action.payload.dashboards[0],
        activeTab:
          reportSelected !== undefined
            ? reportSelected.Name
            : action.payload.dashboards[0].Name,
        isNewReport: false,
        isEditingReport: false
      }
    }
    case 'selectReport': {
      return {
        ...state,
        report: state.dashboards.find((p) => p.Name === action.payload.tab),
        activeTab: action.payload.tab
      }
    }
    case 'newReport': {
      return {
        ...state,
        isNewReport: true,
        isEditingReport: false
      }
    }
    case 'editReport': {
      return {
        ...state,
        isNewReport: false,
        isEditingReport: true,
        report: action.payload.report
      }
    }
    case 'showModal': {
      return {
        ...state,
        configModal: action.payload.configModal,
        showModal: true
      }
    }
    case 'closeModal': {
      return {
        ...state,
        showModal: false,
        configModal: null,
        isEditingReport: action.payload.backToIndex
          ? false
          : state.isEditingReport,
        isNewReport: action.payload.backToIndex ? false : state.isNewReport
      }
    }
    default:
      return state
  }
}

const initialState = {
  dashboards: [],
  report: undefined,
  activeTab: '',
  isNewReport: false,
  isEditingReport: false,
  configModal: null,
  showModal: false
}

export const Dashboard = () => {
  if (window.Zone !== undefined && window.Zone !== null) {
    window.location.reload()
  }

  const [t] = useTranslation(['qlik'])
  const currentTheme = useTheme()
  const useStyles = makeStyles(stylesMui(currentTheme))
  const classes = useStyles()

  const context = useContext(QlikUIContext)

  const container = useRef()

  const [qlikLoaded, qlik, qlikAsync] = useQlik()

  const apiReportsQlik = useReportsQlikApi()

  const [state, dispatch] = useReducer(dashboardReducer, initialState)
  const {
    dashboards,
    report,
    activeTab,
    isNewReport,
    isEditingReport,
    configModal,
    showModal
  } = state

  useEffect(() => {
    if (qlikLoaded) {
      getReports()
    }

    return () => {
      dispatch({ type: 'unmount' })
    }
    // eslint-disable-next-line
  }, [qlikLoaded])

  async function getReports() {
    const resp = await apiReportsQlik.GetReports(
      context.userName,
      context.roles.split(','),
      0
    )
    dispatch({
      type: 'loadReport',
      payload: {
        dashboards: resp
      }
    })
  }

  function reload() {
    window.location.reload(true)
  }

  const handleEditReport = (editReport) => {
    dispatch({ type: 'editReport', payload: { report: editReport } })
  }

  const deleteReport = async () => {
    await apiReportsQlik.DeleteReport(report.UserName, report.FileName, 0)
    reload()
  }

  const handleNewReport = () => {
    dispatch({ type: 'newReport' })
  }

  const onChangeTabHandler = (event, tab) => {
    if (report.Name !== tab) {
      dispatch({
        type: 'selectReport',
        payload: {
          tab
        }
      })

      setTimeout(function () {
        qlik.resize()
      }, 1000)
    }
  }

  return (
    <Card elevation={1} className={classes.cardContainer}>
      <div className='content'>
        <div className={classes.headerButton}>
          <Button
            className={classes.rightButton}
            onClick={handleNewReport}
            color='primary'
            variant='text'
            title={t('qlik:dashboard.new')}
          >
            {t('qlik:dashboard.new')}
          </Button>
          <QlikSyncButton qlikAsync={qlikAsync} onEndSynchronization={reload} />
        </div>
        <div className={styles.tabContent} ref={container}>
          {dashboards && report && (
            <Tabs
              className={classes.tabsRoot}
              value={report.Name}
              onChange={onChangeTabHandler}
              indicatorColor='primary'
              textColor='primary'
            >
              {dashboards.map((rep) => {
                return (
                  <Tab key={rep.Id} label={rep.Name} value={rep.Name}></Tab>
                )
              })}
            </Tabs>
          )}
          {dashboards &&
            report &&
            dashboards.map((tab, index) => {
              let hid =
                activeTab !== ''
                  ? activeTab !== tab.Name
                  : dashboards[0].Name !== tab.Name
              return (
                <div
                  key={tab.Id}
                  role='tabpanel'
                  hidden={hid}
                  id={`simple-tabpanel-${index}`}
                  aria-labelledby={`simple-tab-${index}`}
                >
                  {
                    <QlikReport
                      qlik={qlik}
                      report={tab}
                      reportType='0'
                      onEditReport={handleEditReport}
                      transformRatio={container.current.clientWidth / 24}
                    ></QlikReport>
                  }
                </div>
              )
            })}
        </div>
      </div>

      {isNewReport && (
        <DashboardConfig
          config={{
            reportType: '0',
            activeReportName: '',
            report: '',
            streamId: '',
            ambitId: '',
            editorMode: '0'
          }}
          onEndPersonalization={reload}
          onDeleteReport={deleteReport}
        />
      )}

      {isEditingReport && (
        <DashboardConfig
          config={{
            reportType: '0',
            activeReportName: report.Id,
            report: report,
            streamId: '',
            ambitId: report.AmbitId,
            editorMode: '1'
          }}
          onEndPersonalization={reload}
          onDeleteReport={deleteReport}
        />
      )}

      {showModal && configModal !== null && (
        <DialogModal config={configModal} />
      )}
    </Card>
  )
}
